import React from 'react';
import { getI18NMessage } from 'I18N/I18NHelper';
import {closeCardTypeSettings } from 'js/app/actions/AppActions';
import { saveCardTypeSettings } from '../actions/CardTypeConfigActions';
import AppHelper from 'js/app/AppHelper';
import { showMessage } from 'js/modules/message/actions/MessageActions';
import { BOARD_MESSAGE_CONSTANT } from 'js/modules/message/constants/MessageConstants';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';

class CardTypeConfigView extends React.Component {
	constructor(props) {
		super(props);

        this.state = {
        };
	};

	render() {
        const cardTypeConfig = AppHelper.getAppData( 'card_type_list');

		if ( Object.keys(this.props).length === 0 || !cardTypeConfig ) {
			return false;
        }

        cardTypeConfig.sort((a, b) => a.cardTypeName.localeCompare(b.cardTypeName));
        
		return (
			<div className="cardTypeConfig-container">
                <div className="cardType-heading">{ getI18NMessage("card_type_pop_subtitle") }</div>
                <div className="cardType-body">
                    <ul>
                    {
                        cardTypeConfig.sort((a, b) => a.cardTypeName.localeCompare(b.cardTypeName)).map(cardType => {

                            const colorStyle = {"backgroundColor": cardType.cardColor};
                            const isSelected = (typeof this.state[cardType.cardType] === "boolean") ? this.state[cardType.cardType] : cardType.isSelected;
                            return (
                                <li key={cardType.id}>
                                    <label>
                                        <div className="checkbox-cnt">
                                            <Checkbox
                                                color="primary"
                                                value={ this.state[cardType.cardType] }
                                                onClick={ this.onCheckboxClick.bind(this) }
                                                checked={ isSelected }
                                                data-cardtype={ cardType.cardType }
                                            />
                                            <span className="checkbox"></span>
                                        </div>
                                        <div className="cardtype-color" style={colorStyle}></div>
                                        <div className="cardtype-cnt">{cardType.cardTypeName}</div>
                                    </label>
                                </li>
                            )
                        })
                    }
                    </ul>
                </div>
                <div className="cardType-footer">
                    <div className='float_right btn_panel full_height'>
                        <Button color="primary" onClick={ () => { this.props.store.dispatch(closeCardTypeSettings()) } }>{ getI18NMessage("cancel") }</Button>
                        <Button variant="contained" color="primary" onClick={ this.onApplyBtnClick.bind(this) } >
                            { getI18NMessage("apply") }
                        </Button>
                    </div>
                </div>
            </div>
		);
    };
    

     /* istanbul ignore next */
    onCheckboxClick(event){
        let isSelected = event.target.checked;
        const clickedCardType = event.currentTarget.getAttribute('data-cardtype');

        if (!isSelected) {
            const issueList = this.props.store.getState().appData.appData.issueList || [];

            if ( issueList.some(issue => issue.cardtype === clickedCardType ) ) {
                isSelected = true;

                this.props.store.dispatch( showMessage({
                    type: BOARD_MESSAGE_CONSTANT.TYPE_WARNING,
                    message: getI18NMessage( 'card_type_deselect_failure' )
                }) );
            }
        }

        this.setState({
            [clickedCardType]: isSelected
        });

    };

     /* istanbul ignore next */
    onApplyBtnClick(){

        const cardTypeConfig = AppHelper.getAppData( 'card_type_list');
        const cardTypeListing = cardTypeConfig.map(cardType => {

            if(typeof this.state[cardType.cardType] === "boolean"){
                return {...cardType, isSelected: this.state[cardType.cardType]};
            }
            return {...cardType};

        });

        this.props.store.dispatch(saveCardTypeSettings(cardTypeListing));
    }

}

export default CardTypeConfigView;